module.exports = "../dist/frontend/icons/letters/a.svg?481370404cd0ee09eb07acf8329ebef8";